import { detailOrAuthorUpdate } from "../App/dispatchers";
import { getAppUpdate } from "../../utils/dataTransform/ContentItem/library";
import {
    reset_detail,
    receive_detail,
    update_related_items,
} from "../../reducers/Detail/reducer";
import log from "../../utils/logger/library";
import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { fetchContentItem } from "../../fetch/graphql/contentItem";
import { transformGQLResponseToDetailStructure } from "../../utils/dataTransform/library";
import { fetchRelatedItems } from "../../fetch/graphql/requests/relatedItems/library";
import { CONTENT_TYPES } from "../../pages/Detail/constants";
import { HttpError, GqlError } from "../../utils/errors/http";
import { transformRelatedItems } from "../../utils/dataTransform/library";
import {
    POLITICS_SECTION,
    NEWS_SECTION,
    OPINION_SECTION_FLAGS,
} from "./constants";

/**
 * @param {function} dispatch dispatch.
 * @param {object} json JSON Object.
 * @return {void}
 * title format - {polopoly.title} - {polopoly.site.name} - {polopoly.page.title}
 */
export const dispatchUpdateApp = (json) => (dispatch) => {
    const { pageTitle, meta } = getAppUpdate(json);
    const contentType = json.type;
    dispatch(detailOrAuthorUpdate(pageTitle, meta, contentType));
};

export const fetch_detail = (contentId, preview = "") => {
    return async (dispatch) => {
        dispatch(reset_detail());

        try {
            dispatch(start_loading());

            const { contentItem } = await fetchContentItem(contentId, preview);

            if (!CONTENT_TYPES.includes(contentItem?.type)) {
                log.warn("(fetch_detail) content type not supported!");
                throw new HttpError(404);
            }

            const transformedContentItem =
                transformGQLResponseToDetailStructure(contentItem, contentId);
            dispatch(receive_detail(transformedContentItem));
            dispatch(dispatchUpdateApp(transformedContentItem));
        } catch (error) {
            const gqlError =
                error instanceof Error ? error : new GqlError(error);
            log.error(
                `(fetch_detail) request failed for ${contentId}`,
                gqlError
            );
            throw gqlError;
        } finally {
            dispatch(set_loading_complete());
        }
    };
};

export const fetch_related_items = (algorithmId) => {
    return async (dispatch, getState) => {
        const { app, detail } = getState();
        const content = detail.content;

        if (
            app.baseSection === NEWS_SECTION &&
            app.subSection !== POLITICS_SECTION &&
            !OPINION_SECTION_FLAGS.includes(content.flag) &&
            content.id &&
            content.intlinks.length === 0
        ) {
            try {
                const response = await fetchRelatedItems(
                    content.id,
                    algorithmId
                );
                const relatedItems = transformRelatedItems(response);

                dispatch(update_related_items(relatedItems));
            } catch (error) {
                log.error(
                    `(fetch_related_items) request failed for ${content.id}`,
                    error
                );
                throw error;
            }
        }
    };
};
